import { useCioTrackPageChange } from './useCioTrackPageChange';
import { useSetUserDataToCio } from './useSetUserDataToCio';

/** Вызовите этот хук один раз в роутере. Он делает следующее:
 *   - вызывает useSetUserDataToCio - для обработки кейсов логина/реги и разлогина
 *   - вызывает useCioTrackPageChange - для обработки кейсов перехода между страницами
 */
export function useCio() {
  useCioTrackPageChange();
  useSetUserDataToCio();
}
